<template>
    <div :class="dashboardStore.filter === 'Card' ? 'col-12 mb-3' : 'col-md-7 col-12 mb-3'">
      <div class="card h-100">
        <div class="card-header">
          <h4>Prepaid cards</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-xxl-3 col-lg-3 col-md-3 col-3">
              <h5>Active cards</h5>
              <hr />
              <h3>{{ cards.active_cards ?? 0 }}</h3>
            </div>
            <div class="col-xxl-4 col-lg-4 col-md-4 col-4" v-if="dashboardStore.filter !== 'Card'">
              <h5>Unused terminals</h5>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>1 month</span>
                </div>
                <div class="col-4 text-end">
                  <h3>{{ cards.unused_terminals?.one_month ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('1_month', 'terminal')">View</button>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>2 months</span>
                </div>
                <div class="col-4 text-end">
                  <h3>{{ cards.unused_terminals?.two_months ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('2_month', 'terminal')">View </button>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>3 months</span>
                </div>
                <div class="col-4 text-end">
                  <h3>{{ cards.unused_terminals?.three_months ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('3_month', 'terminal')">View </button>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>4 months</span>
                </div>
                <div class="col-4 text-end">
                  <h3>{{ cards.unused_terminals?.four_months ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('4_month', 'terminal')">View </button>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>5 months</span>
                    </div>
                <div class="col-4 text-end">
                  <h3>{{ cards.unused_terminals?.five_months ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('5_month', 'terminal')">View </button>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>6 months</span>
                    </div>
                <div class="col-4 text-end">
                  <h3>{{ cards.unused_terminals?.six_months ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('6_month', 'terminal')">View </button>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-xxl-4 col-lg-4 col-md-4 col-4">
              <h5>Unused cards</h5>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>1 month</span>
                </div>
                <div class="col-4 text-end">
                  
                  <h3>{{ cards.unused_cards?.one_month ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('1_month', 'card')">View</button>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>2 months</span>
                </div>
                <div class="col-4 text-end">
                  <h3>{{ cards.unused_cards?.two_month ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('2_month', 'card')">View </button>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>3 months</span>
                </div>
                <div class="col-4 text-end">
                  <h3>{{ cards.unused_cards?.three_month ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('3_month', 'card')">View </button>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>4 months</span>
                </div>
                <div class="col-4 text-end">
                
                  <h3>{{ cards.unused_cards?.four_month ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('4_month', 'card')">View </button>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>5 months</span>
                    </div>
                <div class="col-4 text-end">
                  <h3>{{ cards.unused_cards?.five_month ?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('5_month', 'card')">View </button>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4">
                  <span>6 months</span>
                    </div>
                <div class="col-4 text-end">
                  <h3>{{ cards.unused_cards?.six_month?? 0 }}</h3>
                </div>
                <div class="col-4">
                  <p class="text-end">
                    <button class="btn btn-view" @click="applyFilter('6_month', 'card')">View </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue';
  import { useDashboardStore } from '@/store/admin/dashboard';
  import { useTerminalPerformanceStore } from '../../store/admin/terminalPerformance';
  import { useRouter } from 'vue-router';
  
  const dashboardStore = useDashboardStore();
  const terminalStore = useTerminalPerformanceStore();
  const router = useRouter();
  
  const cards = computed(() => dashboardStore.cards);  
  const applyFilter = (inactivePeriod, type) => {
    // type 可以是 'terminal' 或 'card'
    terminalStore.setInactivePeriod(inactivePeriod);
    terminalStore.setFilterType(type); // 新增：設置篩選類型
    router.push('/admin/card-performance');
  };
  </script>
  
    
    <style scoped>
    .btn-view{
      color: #8476f5;
      border: white;
      background-color: white;
    }
  
    .btn-view:hover{
      color: #8476f5;
    }
    </style>
    